import { createRouter, createWebHashHistory } from 'vue-router'

import LoginView from '../views/LoginView.vue'
import { useToast } from 'vue-toastification'
import { authService } from '@/components/services/authentication'
import RegisterView from '@/views/RegisterView.vue'
import { useUserStore } from '@/stores/userStore'

const router = createRouter({
  history: createWebHashHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'Login',
      meta: {
        requiresAuth: false
      },
      component: LoginView
    },
    {
      path: '/register',
      name: 'Register',
      meta: {
        requiresAuth: false
      },
      component: RegisterView
    },
    // {
    //   path: '/login',
    //   name: 'Login',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import('../views/LoginView.vue')
    // },
    {
      path: '/user',
      name: 'LandingUser',
      meta: {
        requiresAuth: true
      },
      component: () => import('../views/LandingUser.vue')
    },
    {
      path: '/criteria',
      name: 'LandingOperator',
      meta: {
        requiresAuth: true,
        requiresOperatorAccess: true
      },
      component: () => import('../views/LangingPageOperator.vue')
    },
    {
      path: '/process_requests',
      name: 'ProcessRequests',
      meta: {
        requiresAuth: true,
        requiresOperatorAccess: true
      },
      component: () => import('../views/ProcessRequestsView.vue')
    },
    {
      path: '/user_settings',
      name: 'UserSettings',
      meta: {
        requiresAuth: true
      },
      component: () => import('../views/UserSettingsView.vue')
    },
    {
      path: '/access_permit_request',
      name: 'AccessPermitRequest ',
      meta: {
        requiresAuth: true
      },
      component: () => import('../views/AccessPermitRequest.vue')
    }
  ]
})
router.beforeEach((to, from, next) => {
  const toast = useToast();
  const userStore = useUserStore();
  if (to.meta.requiresAuth && !authService.isAuthenticated()) {
    // if (authService.isAuthenticated() && to.name !== 'Login') {
    // Show the toast message
    toast.error('Session expired or not authenticated! Please log in.')
    return next({ name: 'Login' })
  }
  if (to.meta.requiresOperatorAccess) {
    if (userStore.hasOperatorRights === false) {
      return next({ name: "LandingUser" });
    }
  }
  next()
})
export default router
